<typography-v2 look="small-bold" class="text-blue-800">
  New leads paused for {{ minutesRemaining }} min
</typography-v2>
